import type { IWalletBalanceSkeleton } from './WalletBalance.helpers';

const WalletBalanceSkeleton = ({ withdraw, isUsd }: IWalletBalanceSkeleton) => {
	const wrapperClass = `walletbalance${withdraw ? ' withdraw' : ''}${isUsd ? ' usd-card bg-dark-navy' : ''}`;

	return (
		<div className={wrapperClass}>
			<div className='walletbalance_icon skeleton-pulse' />

			<div className='walletbalance_content'>
				<div className='walletbalance_content_header'>
					<div className='skeleton-pulse skeleton-text-lg' />
					<div className='skeleton-pulse skeleton-icon-sm' />
				</div>

				<div className='walletbalance_content_body'>
					<div className='skeleton-pulse skeleton-balance' />
					{withdraw && <div className='skeleton-pulse skeleton-button' />}
				</div>
			</div>
		</div>
	);
};

export default WalletBalanceSkeleton;
